import React from 'react';
import PropTypes from 'prop-types';

const ChevronRight = props => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.76594 5.99999L0.165762 11.1133C-0.0376417 11.299 -0.0564526 11.6195 0.123747 11.8291C0.303947 12.0388 0.614919 12.0582 0.818323 11.8724L6.82764 6.38558C6.83967 6.37495 6.85131 6.36364 6.8625 6.35164C7.00917 6.19491 7.03998 5.96134 6.9478 5.7724C6.92607 5.72775 6.8976 5.68584 6.8625 5.64834C6.85131 5.63634 6.83967 5.62502 6.82764 5.61439L0.818323 0.127538C0.614919 -0.0581822 0.303947 -0.0387949 0.123747 0.170841C-0.0564526 0.380476 -0.0376417 0.700974 0.165762 0.886694L5.76594 5.99999Z" fill="#232323" />
  </svg>
);

ChevronRight.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

ChevronRight.defaultProps = {
  className: undefined,
  onClick: undefined,
  onKeyDown: undefined,
};

export default ChevronRight;
